const React = require('react');
const { default: TextField } = require('@mui/material/TextField');
const { default: Styled, css } = require('styled-components');
const { singleLineFieldStyles } = require('./singleLineFieldStyles');

const internals = {};

internals.normalizeRequiredLabel = ({
    label,
    required
}) => {

    if (!required || typeof label !== 'string') {
        return label;
    }

    return label.replace(/\s*\*+\s*$/, '');
};

module.exports = function ControlledTextField(props) {
    const {
        BaseTextField,
        SingleLineTextField
    } = internals;

    const {
        id,
        label,
        value,
        onBlur,
        onChange,
        onFocus,
        maxLength,
        textFieldProps = {}
    } = props;

    const Component = textFieldProps.singleLine === false
        ? BaseTextField
        : SingleLineTextField;
    const required = !!textFieldProps.required;

    return <Component
        id={id}
        label={internals.normalizeRequiredLabel({
            label,
            required
        })}
        value={value ?? ''}
        onBlur={onBlur}
        onChange={(event) => {

            if (typeof onChange === 'function') {
                onChange(event.target.value, event);
            }
        }}
        onFocus={onFocus}
        inputProps={{
            maxLength,
            ...(textFieldProps.inputProps || {})
        }}
        fullWidth
        {...textFieldProps}
        required={required}
        $fieldStyles={textFieldProps.fieldStyles}
    />;
};

internals.BaseTextField = Styled(TextField)`
    ${({ $fieldStyles }) => css`${$fieldStyles || ''}`}
`;

internals.SingleLineTextField = Styled(TextField)`
    ${singleLineFieldStyles}
    ${({ $fieldStyles }) => css`${$fieldStyles || ''}`}
`;
